'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024$0024anon$002443 from "./presto.types$-Credential-Hash$$anon$43.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialHash$() {
  this.c5k = null;
  this.c5l = false;
  this.c5i = null;
  this.c5j = false;
  this.c5m = null;
  this.c5n = false;
  this.c5o = null;
  this.c5p = false;
}
export { $c_Lpresto_types$CredentialHash$ as $c_Lpresto_types$CredentialHash$ };
$p = $c_Lpresto_types$CredentialHash$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialHash$;
/** @constructor */
function $h_Lpresto_types$CredentialHash$() {
}
export { $h_Lpresto_types$CredentialHash$ as $h_Lpresto_types$CredentialHash$ };
$h_Lpresto_types$CredentialHash$.prototype = $p;
$p.gT = (function() {
  if ((!this.c5l)) {
    this.c5k = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c5l = true;
  }
  return this.c5k;
});
$p.ep = (function() {
  if ((!this.c5j)) {
    this.c5i = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c5j = true;
  }
  return this.c5i;
});
$p.cJH = (function() {
  if ((!this.c5n)) {
    this.c5m = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c5n = true;
  }
  return this.c5m;
});
$p.aeg = (function() {
  if ((!this.c5p)) {
    this.c5o = new $j_presto$002etypes$0024$002dCredential$002dHash$0024$0024anon$002443.$c_Lpresto_types$CredentialHash$$anon$43(this);
    this.c5p = true;
  }
  return this.c5o;
});
var $d_Lpresto_types$CredentialHash$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialHash$, "presto.types$CredentialHash$", ({
  YX: 1,
  D: 1
}));
export { $d_Lpresto_types$CredentialHash$ as $d_Lpresto_types$CredentialHash$ };
var $n_Lpresto_types$CredentialHash$;
function $m_Lpresto_types$CredentialHash$() {
  if ((!$n_Lpresto_types$CredentialHash$)) {
    $n_Lpresto_types$CredentialHash$ = new $c_Lpresto_types$CredentialHash$();
  }
  return $n_Lpresto_types$CredentialHash$;
}
export { $m_Lpresto_types$CredentialHash$ as $m_Lpresto_types$CredentialHash$ };
//# sourceMappingURL=presto.types$-Credential-Hash$.js.map
